import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Sabine M.',
  age: 52,
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=200',
  quote: 'Ich war kurz davor, einen Beratungstermin für eine OP zu vereinbaren. Nach 6 Wochen mit Rylte hat mich meine Schwester gefragt, ob ich im Urlaub war. Die morgendlichen Schwellungen sind fast komplett weg.'
}, {
  id: 2,
  name: 'Claudia T.',
  age: 48,
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=200',
  quote: 'Jahrelang teure Cremes gekauft, die nichts gebracht haben. Das Gerät fühlt sich an wie eine sanfte Massage. Der dunkle Schatten unter dem linken Auge ist deutlich heller geworden. Jeden Cent wert.'
}, {
  id: 3,
  name: 'Martina K.',
  age: 55,
  image: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?auto=format&fit=crop&q=80&w=200',
  quote: "Man sieht nicht über Nacht aus wie 30, aber das war auch nicht mein Ziel. Ich sehe einfach wieder ausgeruht aus. Der 'Hundeblick' ist weg, das Gewebe wirkt viel straffer."
}];
export function TestimonialCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section className="py-16 bg-slate-900 text-white overflow-hidden" data-id="element-96">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-97">
        <h2 className="text-3xl sm:text-4xl font-bold mb-12 text-white" data-id="element-98">
          Was Frauen berichten
        </h2>

        <div className="relative" data-id="element-99">
          <div className="flex items-center justify-center gap-4 sm:gap-8" data-id="element-100">
            <button onClick={prev} className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors hidden sm:block" aria-label="Vorherige" data-id="element-101">
              <ChevronLeft className="w-6 h-6" data-id="element-102" />
            </button>

            <div className="w-full max-w-lg relative min-h-[300px]" data-id="element-103">
              <AnimatePresence mode="wait" data-id="element-104">
                <motion.div key={currentIndex} initial={{
                opacity: 0,
                x: 50
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: -50
              }} transition={{
                duration: 0.3
              }} className="bg-slate-800 rounded-2xl p-8 shadow-2xl border border-slate-700 absolute inset-0 flex flex-col items-center justify-center" data-id="element-105">
                  <img src={testimonials[currentIndex].image} alt={testimonials[currentIndex].name} className="w-20 h-20 rounded-full object-cover mb-4 border-2 border-brand-500" data-id="element-106" />
                  <div className="flex gap-1 mb-4 text-brand-400" data-id="element-107">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-108" />)}
                  </div>
                  <p className="text-lg italic text-slate-300 mb-6 leading-relaxed" data-id="element-109">
                    "{testimonials[currentIndex].quote}"
                  </p>
                  <div className="font-bold text-white" data-id="element-110">
                    {testimonials[currentIndex].name},{' '}
                    {testimonials[currentIndex].age}
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

            <button onClick={next} className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors hidden sm:block" aria-label="Nächste" data-id="element-111">
              <ChevronRight className="w-6 h-6" data-id="element-112" />
            </button>
          </div>

          <div className="flex justify-center gap-2 mt-8" data-id="element-113">
            {testimonials.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`w-2.5 h-2.5 rounded-full transition-colors ${i === currentIndex ? 'bg-brand-500' : 'bg-slate-600'}`} aria-label={`Gehe zu Testimonial ${i + 1}`} data-id="element-114" />)}
          </div>
        </div>
      </div>
    </section>;
}